<!--  -->
<template>
    <div class="registerMessage padding-20 bgc box-shadow">
        <div class="search">
            <el-date-picker value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="params.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-input v-model="params.customername" placeholder="请输入用户名"></el-input>
            <el-button class="search_btn" @click="handleSearch">搜索</el-button>
            <el-button class="export_btn" @click="exportCommonUserFormList">导出</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="用户名称" class-name="center" width="250px">
                <template slot-scope="scope">
                    <div class="headerurl_name">
                        <div class="headerurl">
                            <img :src="scope.row.headerurl" alt="">
                        </div>
                        <div class="name">{{scope.row.custmername}}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="填写时间" class-name="center" prop="datetime" width="160px"></el-table-column>
            <el-table-column show-overflow-tooltip :label="item.colname" class-name="center" v-for="(item, index) in collist" :key="index">
                <template slot-scope="scope">
                    <div v-if="scope.row.colvaluelist[index].colvalue">{{scope.row.colvaluelist[index].colvalue}}</div>
                    <div v-else>--</div>
                </template>
            </el-table-column>
        </el-table>
        <page ref="page" @getList="getCommonUserFormList" :total="total" />
    </div>
</template>

<script>
import page from '@/base/page/page'
import {dateFormat} from 'common/js/tools'
import {mapActions, mapGetters} from 'vuex'
import {getCommonUserFormList, exportCommonUserFormList} from 'api/operateToolApi'
export default {
    data() {
        return {
            params: {
                date: '',
                customername: '',
                innerid: 'Parks_Form_Reg'
            },
            tableData: [],
            total: 0,
            collist: []
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        this.$refs.page.pagination.page = 1
        this.getCommonUserFormList(this.page)
    },
    methods: {
        getCommonUserFormList(page) {
            this.setLoading(true)
            const params = JSON.parse(JSON.stringify(this.params))
            if (params.date.length) {
                params.begintime = params.date[0]
                params.endtime = params.date[1]
            }
            delete params.date
            getCommonUserFormList({
                data: Object.assign({}, page, params),
                success: res => {
                    this.setLoading(false)
                    if (page.page === 1) {
                        this.collist = res.data.collist
                    }
                    // this.page.page = page.page
                    this.tableData = res.data.content
                    this.total = res.data.pageinfo.rowCount
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        handleSearch() {
            this.setPage({page: 1, pageSize: 10})
            this.$refs.page.pagination.page = 1
            this.getCommonUserFormList(this.page)
        },
        exportCommonUserFormList() {
            this.setLoading(true)
            const params = JSON.parse(JSON.stringify(this.params))
            if (params.date.length) {
                params.begintime = params.date[0]
                params.endtime = params.date[1]
            }
            delete params.date
            exportCommonUserFormList({
                data: params,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '登记信息' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        page
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .registerMessage {
        .search {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-bottom: 20px;
            .el-date-editor {
                margin-right: 30px;
                .el-input__icon {
                    line-height: 24px;
                }
                .el-range-separator {
                    line-height: 24px;
                }
            }
            .el-input {
                width: 220px;
                margin-right: 30px;
            }
            .search_btn {
                margin-right: 30px;
            }
            .export_btn {
                margin-left: 0;
            }
        }
        .el-table {
            .center {
                .cell {
                    text-align: center;
                }
            }
            .left {
                .cell {
                    text-align: left;
                }
            }
            .headerurl_name {
                display: flex;
                align-items: center;
                justify-content: center;
                .headerurl {
                    width: 60px;
                    height: 60px;
                    margin-right: 15px;
                    img {
                        width: 60px;
                        height: 60px;
                        border-radius: 50%;
                    }
                }
                .name {
                    max-width: 145px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 14px;
                    color: #606266;
                    text-align: left;
                    flex: 1;
                }
            }
        }
    }
</style>